import React, { Component } from 'react'

import {notification} from "antd";
// service
import AppService from '../../app.service'
// model
import MessageDetails from '../../notice/model/messageDetails'
// components
import MessageDetailsModal from './modal/messageDetails'
// img
import TeachEvaluaIcon from '@/assets/image/head/teachevalua.svg'

interface iProps {
    msg: MessageDetails,
    getNoticeList: () => void,
    getNumber: () => void,
    displayWrap?: boolean
}
interface iState {
    modalVisible: boolean,
    readStatus: boolean
}

export default class messageItem extends Component<iProps, iState> {
    private appService: AppService = new AppService()
    state: iState = {
        modalVisible: false,
        readStatus: false
    }
    checkMessageDetails = async () => {
        let data = await this.appService.markReadMessage([this.props.msg.messageId])
        if (data === 'ok') {
            await this.setState({readStatus: true})
            await this.setState({modalVisible: true})
            this.props.getNoticeList()
        }
    }
    // 删除消息
    deleteMessage = async () => {
        const that = this
        let data = await that.appService.deleteMessage([that.props.msg.messageId])
        if (data === 'ok') {
            notification['success']({
                message: '删除成功',
                duration: 1,
                async onClose () {
                    await that.props.getNumber()
                    that.setState({modalVisible: false})
                }
            })
            
        }
    }
    componentWillReceiveProps (nextProps) {
        if (this.props.msg != nextProps.msg) {
            this.setState({readStatus: false})
        }
    }
    render() {
        let {msg, displayWrap = true} = this.props
        let {modalVisible, readStatus} = this.state
        return (
            <>
                <div className="messageItem" onClick={this.checkMessageDetails}>
                    {displayWrap && 
                    <>
                        <div className="messageItem_icon">
                            <img src={TeachEvaluaIcon}/>
                        </div>
                        <div className="messageItem_content">
                            <div className="messageItem_title"
                                style={{color: !readStatus ? 'rgba(0,0,0,.85)' : 'rgba(0,0,0,.35)'}}>
                                {msg.content}
                            </div>
                            <div className="messageItem_bottom" style={{color: !readStatus ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.35)'}}>
                                <div className="messageItem_origin">{msg.systemName}</div>
                                <div className="messageItem_time">{msg.sendTime}</div>
                            </div>
                        </div>
                    </>}
                    {
                        !displayWrap &&
                        <div className="messageItem_nowrap">
                            <div className="messageItem_nowrap_title">
                                <img src={TeachEvaluaIcon} width="18" height="18" />
                                <span className="messageItem_nowrap_title_text" style={{color: !readStatus ? 'rgba(0,0,0,.85)' : 'rgba(0,0,0,.35)'}}>{msg.content}</span>
                            </div>
                            <div className="messageItem_nowrap_mes">
                                <span className="messageItem_nowrap_senduser" style={{color: !readStatus ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.35)'}}>{msg.systemName}-{msg.sendTime}</span>
                            </div>
                        </div>
                    }
                </div>
                <MessageDetailsModal
                    msg={msg}
                    visible={modalVisible}
                    onCancel={() => {this.setState({modalVisible: false})}}
                    deleteMessage = {this.deleteMessage}
                ></MessageDetailsModal>
            </>
            
        )
    }
}
